import React, { useState } from 'react';
import "./contact.css";
import { db, collection, addDoc } from '../../firebase/firebaseconfiq'; // Import Firebase
import ThreeScene from '../profile/threescene';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    comments: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "contacts"), formData);
      alert("Message sent successfully!");
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        comments: ''
      });
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("Error sending message, please try again.");
    }
  };

  return (
    <div className='wrapper'>
       <ThreeScene/>
      <div className="form-container">
       
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>Contact Us</h2>

          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input type="text" id="name" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input type="tel" id="phone" name="phone" placeholder="Your Phone Number" value={formData.phone} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="service">Select Service</label>
            <select id="service" name="service" value={formData.service} onChange={handleChange} required>
              <option value="" disabled>Select a Service</option>
              <option value="web-development">Web Development</option>
              <option value="app-development">App Development</option>
              <option value="ui-ux-design">UI/UX Design</option>
              <option value="desktop-application-development">Desktop Application Development</option>
              <option value="cloud-integration-dev-ops">Cloud Integration & Dev Ops</option>
              <option value="machine-learning-ai-solution">Machine Learning and AI Solutions</option>
              <option value="database-management">Database Managaement & Integration</option>
              <option value="digital-marketing-solution">Digital Marketing Solutions</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="comments">Comments</label>
            <textarea id="comments" name="comments" rows="5" placeholder="Your Message" value={formData.comments} onChange={handleChange} required></textarea>
          </div>

          <div className="form-group">
            <button type="submit">Send</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Contact;
